module.exports = __webpack_public_path__ + "static/media/account.29b481d6.svg";